__turbopack_context__.v({
  "checkAudioWrapper": "component_page-module-scss-module__9uG9ZG__checkAudioWrapper",
  "contentWrapper": "component_page-module-scss-module__9uG9ZG__contentWrapper",
});
